/**
 * Created by Carsten Bühler
 * User: CBuehler on 09.11.2015
 * Copyright: xdot GmbH 2015
 */


import { Client } from 'external/lwr-client';
import { ApiUtil } from 'plugin/liferay-widgets-react-web';

//const stateValueService = (m, o) => Client.invoke('/state.statevalue/' + m, o);
const stateValueServiceWithContext = (m, o, c) => Client.invokeWithContext('/state.statevalue/' + m, o, c);

let api = {

    loadStatesValuesFromService(query) {
        return stateValueServiceWithContext('list-attached-by-prop-name.6', {
            className: query.byClassName,
            classPK: query.byId,
            propName: query.byPropName,
            start: query.start,
            end: query.end
        }, {});
    }
};

ApiUtil.namedApi('StateValueWebApi', api);

export default api;



// WEBPACK FOOTER //
// ./js/webapi/StateValueWebApi.js